// When manually releasing a version, the default version code provided by Google,
// e.g., "1903275663 (22.4.0)", does not match the expected format "22.4.0".
// This function extracts the version from the default version code.
export function extractVersion(input: string): string | undefined {
  const regex = /\(?(\d+\.\d+\.\d+)\)?/;
  const match = input.match(regex);
  return match ? match[1] : undefined;
}
